import { DASHBOARD_LINKS } from '@/modules/Dashboard/DashboardLinks.ts';
import { FILE_DETAIL_LINKS } from '@/modules/FileDetail/FileDetailLinks';
import FileDetail from '@/modules/FileDetail/pages/FileDetail.tsx';
import StatusTransition from '@/modules/FileDetail/pages/StatusTransition.tsx';
import Actions from '@/modules/FileDetail/pages/actions';
import Documentation from '@/modules/FileDetail/pages/documentation.tsx';
import Information from '@/modules/FileDetail/pages/information.tsx';
import { OFFLINE_FILES_ROUTES } from '@/modules/OfflineFiles/OfflineFilesRoutes';
import { Navigate, Outlet, RouteObject } from 'react-router-dom';

export const FileDetailRoutes: RouteObject[] = [
  {
    index: true,
    element: <Navigate to={DASHBOARD_LINKS.homePage} />,
  },
  {
    path: ':id',
    element: <Outlet />,
    children: [
      { index: true, element: <FileDetail /> },
      {
        path: FILE_DETAIL_LINKS.statusTransition,
        element: <StatusTransition />,
      },
      {
        path: FILE_DETAIL_LINKS.documentation,
        element: <Documentation />,
      },
      {
        path: FILE_DETAIL_LINKS.information,
        element: <Information />,
      },
      {
        path: FILE_DETAIL_LINKS.actions,
        element: <Actions />,
      },
      ...OFFLINE_FILES_ROUTES,
    ],
  },
];
